import React from "react"
import { Card, CardContent, Typography, makeStyles } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import TableView from "../../common/TableView/TableView"
import { getFormattedTime } from "../../../utils"

const useStyles = makeStyles((theme) => ({
	card: {
		height: "460px",
	},
	cardContent: {
		padding: "24px",
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: theme.typography.subTitle1.fontWeight,
		paddingBottom: "16px",
	},
}))

const ExecutionTimeTable = () => {
	const [t] = useTranslation("global")
	const caseDetails = useSelector((state) => state.bifrostCaseDetails.caseDetails)
	const isPageLoading = useSelector((state) => state.bifrostCaseDetails.isLoading)
	const classes = useStyles()

	const getRows = () => {
		return [
			{
				id: "total",
				timeGroup: t("bifrost.table_headers.total"),
				time: getFormattedTime(caseDetails?.total_time),
			},
			{
				id: "upload",
				timeGroup: t("bifrost.table_headers.upload"),
				time: getFormattedTime(caseDetails?.upload_time),
			},
			{
				id: "extract",
				timeGroup: t("bifrost.table_headers.extract"),
				time: getFormattedTime(caseDetails?.text_extraction_time + caseDetails?.post_extraction_time),
			},
			{
				id: "extractNames",
				timeGroup: t("bifrost.table_headers.extractNames"),
				time: getFormattedTime(caseDetails?.pii_extraction_time),
			},
			{
				id: "kbMaking",
				timeGroup: t("bifrost.table_headers.kbMaking"),
				time: getFormattedTime(caseDetails?.kbmaking_time),
			},
		]
	}

	const getColumns = () => {
		return [
			{
				field: "timeGroup",
				headerName: t("bifrost.table_headers.timeGroup"),
				sortable: false,
				resizable: true,
				flex: 0.2,
				width: 170,
			},
			{
				field: "time",
				headerName: t("bifrost.table_headers.time"),
				sortable: false,
				resizable: true,
				flex: 0.2,
				width: 170,
			},
		]
	}

	return (
		<Card className={classes.card}>
			<CardContent className={classes.cardContent}>
				<Typography variant="subtitle1" className={classes.title}>
					{t("bifrost.titles.executionTime")}
				</Typography>
				<TableView
					columns={getColumns()}
					rows={getRows()}
					isLoading={isPageLoading}
					pageInfo={{
						page: 1,
						pageSize: 5,
						rowsPerPageOptions: [],
						totalRowCount: 5,
						paginationMode: "server",
						handlePageChange: () => {},
						handlePageSizeChange: () => {},
					}}
					sortInfo={{
						sortingMode: "server",
						sortModel: [],
						onSortModelChange: () => {},
					}}
					footerInfo={{
						hideFooter: true,
						hideSelectionCount: true,
						hidePagination: true,
					}}
					checkboxSelection={false}
					topBarInfo={{
						show: false,
						rightSection: "",
					}}
				/>
			</CardContent>
		</Card>
	)
}

export default ExecutionTimeTable
